import React, { useEffect, useRef } from "react";
import $ from "jquery";

const lockIcon = require("../../../../app/assets/images/gss-lock-icon.svg");
const restrictedIcon = require("../../../../public/images/restricted.svg");
const unpublishedIcon = require("../../../../public/images/unpublished.svg");
const publicIcon = require("../../../../public/images/public.svg");

type EventType = {
  id: number;
  publishMode: string;
  password: string | null;
};

const getIconDetails = (event: EventType) => {
  if (event.publishMode === "unpublished") {
    return {
      icon: unpublishedIcon,
      msg: "Unpublished",
      size: 20
    };
  }

  if (event.publishMode === "restricted") {
    return {
      icon: restrictedIcon,
      msg: "Restricted",
      size: 16
    };
  }

  if (event.publishMode === "public") {
    return event.password
      ? {
          icon: lockIcon,
          msg: `Password Protected`,
          size: 20
        }
      : {
          icon: publicIcon,
          msg: "Public",
          size: 16
        };
  }

  return {
    icon: publicIcon,
    msg: "Public",
    size: 16
  };
};

const PublishModeIcon: React.FC<{
  event: EventType;
  showActionTooltip: (id: number | null, title: string, type: string) => void;
}> = ({ event, showActionTooltip }) => {
  const iconRef = useRef<HTMLImageElement | null>(null);
  const { icon, msg, size } = getIconDetails(event);

  return (
    <span
      className="ws-album-info-icon"
      id={`publish-icon-${event.id}`}
      style={{ width: size }}
      data-toggle="tooltip"
      data-placement="top"
      data-container="body"
      onMouseEnter={e => {
        showActionTooltip(event.id, msg, "publish");
      }}
    >
      <img src={icon} ref={iconRef} alt="publish mode icon" />
    </span>
  );
};
export default PublishModeIcon;
